import { emptyMainUrls } from '../consts/emptyMainUrls'
import MAIN_MODULES from '../../../../../config/modules/main.json'
import { MinimalModule, IMicrofront, MinimalVersion } from '../../../interfaces/MFE/IMicrofront'
import { getModuleVersionURL } from '../../versions/get-version-url'
import { getLocalMfeConfig } from '../../../hooks/ModuleFederation/local-mfe-config'

export function getMainModulesUrl (microfronts: {
  discovered: IMicrofront[]
  downloaded: MinimalVersion[]
}) {
  const mainUrls = { ...emptyMainUrls }
  for (const mainModule of MAIN_MODULES as MinimalModule[]) {
    const localConfig = process.env.NODE_ENV === 'development'
      ? getLocalMfeConfig(mainModule.mfe_name)
      : null

    if (localConfig) {
      mainUrls[mainModule.mfe_name] = localConfig.url
    } else {
      const moduleUrl = getModuleVersionURL({ featureId: mainModule.mfe_id, microfronts })
      mainUrls[mainModule.mfe_name] = moduleUrl
    }
  }

  return mainUrls
}
